import React from 'react';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import './styles.scss';

const doughnut = props => {
  const { labels, data: chartData, height, title } = props;

  const numOr0 = n => (isNaN(n) ? 0 : n);

  const data = {
    labels: labels.map(item => item.label),
    datasets: [
      {
        data: chartData,
        backgroundColor: labels.map(item => item.color),
      },
    ],
  };

  return (
    <div className="element-box doughnut">
      <p className="form-header text-medium">{title} </p>
      <div className="el-chart-w">
        <Doughnut
          height={height}
          data={data}
          options={{
            legend: {
              display: false,
            },
            animation: {
              animateScale: true,
            },
            cutoutPercentage: 80,
          }}
        />
        <div className="inside-donut-chart-label">
          <strong>{chartData.reduce((a, b) => numOr0(a) + numOr0(b))}</strong>
        </div>
      </div>
      <div className="el-legend">
        {labels.map( (item, key) => (
          <div className="legend-value-w" key={key}>
            <div
              className="legend-pin"
              style={{ backgroundColor: item.color }}
            />
            <div className="legend-value">{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

doughnut.defaultProps = {
  height: 165,
  title: 'Chart',
};

doughnut.propTypes = {
  labels: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  height: PropTypes.number,
  title: PropTypes.string,
};

export default doughnut;
